"use client";

import { isChunkLoadError, reloadForChunkError } from "@/shared/chunk-reload";
import { useEffect } from "react";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    if (isChunkLoadError(error)) {
      reloadForChunkError();
    }
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          fontFamily: "sans-serif",
          backgroundColor: "#eef1f6",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h1>Something went wrong</h1>
          <p>{error?.message || "An unexpected error has occurred."}</p>
          <button onClick={() => reset()} style={{ padding: "10px 24px", fontSize: "16px", cursor: "pointer" }}>
            Try Again
          </button>
        </div>
      </body>
    </html>
  );
}
